import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function CookiesPolicy() {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-white font-body">
      <nav className="sticky top-0 z-50 bg-[#090D17] border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
          <div className="h-16 flex items-center justify-between">
            <div className="flex items-center gap-2.5 cursor-pointer" onClick={() => navigate('/')}>
              <img src="https://customer-assets-jai6qajn.emergentagent.net/job_38d96a59-41a3-4967-8296-b7ba8cd6e1a1/artifacts/rrpmz7yf_logo%20%287%29.png" alt="OwnerSide" className="h-7 w-7 object-contain" />
              <span className="font-heading text-lg font-semibold tracking-tight text-white">OwnerSide</span>
            </div>
            <button onClick={() => navigate('/')} className="flex items-center gap-1.5 text-sm text-white/70 hover:text-white transition-colors">
              <ArrowLeft className="h-3.5 w-3.5" /> Home
            </button>
          </div>
        </div>
      </nav>
      <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-16 py-16 sm:py-20">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-slate-950 mb-3">Advertising & Cookies</h1>
        <p className="text-sm text-slate-400 mb-12">Last updated: August 18, 2026</p>

        <div className="prose-custom space-y-10 text-slate-600 text-[15px] leading-relaxed">
          <section>
            <h2 className="font-heading text-xl font-bold text-slate-950 mb-3">1. What Are Cookies?</h2>
            <p>Cookies are small text files that can be stored on your device when you visit a website. They can help a website recognize your device and remember information about your visit, such as your preferences and actions.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-slate-950 mb-3">2. Our Current Use of Cookies</h2>
            <p>The OwnerSide website (owner-side.com) does not currently use cookies for advertising, analytics, or tracking purposes. We do not currently deploy Google Analytics, Google Ads, Meta (Facebook) Pixel, remarketing tags, or any similar third-party tracking technology on our website.</p>
            <p className="mt-3">If this changes in the future — for example, if we begin using analytics to understand website performance — we will update this policy to clearly describe what is used and why, before it is deployed.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-slate-950 mb-3">3. Third-Party Services</h2>
            <p>We do not currently use third-party advertising or analytics services on our website. This section will be updated if that changes.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-slate-950 mb-3">4. Managing Cookies in Your Browser</h2>
            <p>Even though our website does not currently set advertising or analytics cookies, most web browsers allow you to view and control cookies stored by any website you visit through their settings, typically found in the "Options" or "Preferences" menu:</p>
            <ul className="list-disc pl-5 space-y-1 mt-3">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#0E7C72] hover:underline">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" rel="noopener noreferrer" className="text-[#0E7C72] hover:underline">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#0E7C72] hover:underline">Apple Safari</a></li>
              <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-[#0E7C72] hover:underline">Microsoft Edge</a></li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-slate-950 mb-3">5. Do Not Track</h2>
            <p>Some browsers include a "Do Not Track" (DNT) feature that signals to websites that you do not want to be tracked. There is currently no industry-standard technology for recognizing DNT signals. As noted above, our website does not currently use tracking cookies regardless of this setting.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-slate-950 mb-3">6. Advertising Practices</h2>
            <p>OwnerSide does not currently run online advertising campaigns or use remarketing on our website. If we begin doing so in the future, we will update this policy to describe our advertising and tracking practices, and all advertising content will clearly identify OwnerSide as the advertiser and comply with applicable advertising standards and regulations.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-slate-950 mb-3">7. Changes to This Policy</h2>
            <p>We may update this Advertising & Cookies Policy from time to time to reflect changes in our practices or legal requirements. The revised policy will be posted on our website with an updated "Last updated" date.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-slate-950 mb-3">8. Contact Us</h2>
            <p>If you have questions about this policy, please contact us:</p>
            <div className="mt-3 bg-slate-50 rounded-xl p-5 text-sm space-y-1">
              <p><strong>OwnerSide Business Services Ltd.</strong></p>
              <p>Email: info@owner-side.com</p>
            </div>
          </section>

          <section>
            <p>For more information about how we handle your personal data, please see our <Link to="/privacy" className="text-[#0E7C72] hover:underline">Privacy Policy</Link> and <Link to="/terms" className="text-[#0E7C72] hover:underline">Terms of Use</Link>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
